import { usePendingEntries } from '@/hooks/usePendingEntries'
import { getPeriodBounds, getPeriodInfo } from '@/lib/periods'
import type { PeriodConfig } from '@/types/periods'

export function useReportingData(periodDate: Date, periodConfig: PeriodConfig, enabled = true) {
    const { start, end } = getPeriodBounds(periodDate, periodConfig)
    const periodInfo = getPeriodInfo(periodDate, periodConfig)

    const { entriesByUser, isLoading } = usePendingEntries({
        startDate: start,
        endDate: end,
        enabled,
    })

    const hasEntries = Object.keys(entriesByUser).length > 0

    return {
        entriesByUser,
        hasEntries,
        isLoading,
        periodLabel: periodInfo.label,
    }
}
